import React, { useState } from "react";
import {Helmet} from "react-helmet";
import IdpStudyabroadForms from "../../components/idp-studyabroad/idpStudyabroadContainer";
import "../../assets/css/idp-medical.css";
import "../../assets/css/idp-studyabroad.css";
import QuestionCounter from "../../components/common/questionCounter";
import { AiOutlineClose } from "react-icons/ai";
import AnimationContainer from "../../components/idp-studyabroad/animationContainer";

const IdpStudyAbroad = () => {
  const [countryIds, setCountryIds] = useState('')
  const [isExitIdp, setIsExitIdp] = useState(false)
  const [questionCount, setQuestionCount] = useState({})
  
  const getCountryIds = (data)=>{
    setCountryIds(data?.country)
    let item
    let checkedQuestion = 0
    let validateData = Object.values(data)
    for(item of validateData) {
      if (!Array.isArray(item)) {
        if(item === '') checkedQuestion += 1
      }
      if (item.length === 0) checkedQuestion += 1
    }
    setQuestionCount({
      total: Object.values(data)?.length,
      filled: Object.values(data)?.length - checkedQuestion,
      percentage: Math.round((100 * (Object.values(data)?.length - checkedQuestion)) / Object.values(data)?.length)
    })
  }
  const exitIDP = ()=>{
    setIsExitIdp(true)
  }

  return (<>
    <Helmet>
        <title>IDP Study Abroad</title>
    </Helmet>
    <div className="idp_wrapper idp_studyabroad">
      <div className="idp_container">

        <AnimationContainer countryIds={countryIds} />
        
        <div className="idp_form_wrapper">
          <div className="exit_idp"><span onClick={exitIDP}><AiOutlineClose/></span></div>
          <div className="idp_abrod_about_us">
            <h2 className="about_us_heading">
              Help us <strong>Personalize</strong> your{" "}
              <br /><strong>experience</strong>
            </h2>
             
            {/* <QuestionCounter strokeWidth={8} percentage={questionCount?.percentage} totalQuestion={questionCount?.total} filledQuestion={questionCount?.filled} bgColor="#cccccc" fcolor="#d0f45b" /> */}

            <p className="idp_breif">
              Fill correct information to receive guidance that fits your interest and goal.
            </p>
          </div>

          <IdpStudyabroadForms getCountryIds={getCountryIds} isExitIdp={isExitIdp} setIsExitIdp={setIsExitIdp} />
        </div>
      </div>
    </div>
    </>);
};

export default IdpStudyAbroad;
